/* eslint-disable no-restricted-imports */
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core'
import { Col, Divider, Progress, Row, Tag } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'

import { showErrorMessage } from '../../../actions/notification'
import makeRequest from '../../../libs/request'
import { PERMISSIONS_FREE, PERMISSIONS_PLAN, PERMISSIONS_PRO } from '../../../../_metronic/utils/utils'

export const getStorageLimit = (value, isFree) => {
  if (!value) return "0 MB";
  let storage_limit = value ? value : isFree ? 500 : 5120;
  return storage_limit >= 1048576
    ? `${(storage_limit / 1048576).toFixed(2)} TB`
    : storage_limit >= 1024
      ? `${(storage_limit / 1024).toFixed(2)} GB`
      : `${storage_limit.toFixed(2)} MB`;
};

export const getStorageLimitNotDefault = (value, isFree) => {
  if (!value) return "0 MB";
  let storage_limit = value;
  return storage_limit >= 1048576
    ? `${(storage_limit / 1048576).toFixed(2)} TB`
    : storage_limit >= 1024
      ? `${(storage_limit / 1024).toFixed(2)} GB`
      : `${storage_limit.toFixed(2)} MB`;
};

export default function BillingComponent({ value, show, plan }) {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [totalRows, setTotalRows] = useState(0)
  const [rows, setRow] = useState([])
  const [page2, setPage2] = useState(0)
  const [rowsPerPage2, setRowsPerPage2] = useState(10)
  const [totalRows2, setTotalRows2] = useState(0)
  const [rows2, setRow2] = useState([])
  const [plansInfo, setPlansInfo] = useState()
  const [card, setCard] = useState({})

  let isCompanyBase = plan?.price?.type === "base"
  const isFree = plan?.key === 'free'

  const storeTotal = value?.storage_limit ? value?.storage_limit : isFree ? 500 : 5120;
  const storage_size = value?.storage_size ? value?.storage_size?.toFixed(3) : 0;
  const percent = (storage_size / storeTotal) * 100;

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }
  const handleChangePage2 = (event, newPage) => {
    setPage2(newPage)
  }

  const handleChangeRowsPerPage2 = (event) => {
    setRowsPerPage2(parseInt(event.target.value, 10))
    setPage2(0)
  }

  const getData = () => {
    makeRequest('get', `icpa/companies/${value?._id}/cards`, {
      type: 'ICPA_EAMDINT',
    })
      .then(({ data }) => {
        if (data.signal) {
          setCard(data.data)
        } else {
          return showErrorMessage(data.message)
        }
      })
      .catch((err) => {
        console.log(err)
      })
    makeRequest('get', `icpa/plans/get-info/companies/${value?._id}`, {
      type: 'ICPA_EAMDINT',
    })
      .then(({ data }) => {
        if (data.signal) {
          setPlansInfo({
            expires_on: data.data?.expires_on
              ? moment(data.data?.expires_on).format('DD/MM/YYYY')
              : null,
            next_bill_on: data.data?.next_bill_on
              ? moment(data.data?.next_bill_on).format('DD/MM/YYYY')
              : null,
          })
        } else {
          return showErrorMessage(data.message)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const getInvoicesList = async (page = 0, rowsPerPage = 10) => {
    let invoicesList = null
    makeRequest('get', `icpa/invoices/get-all`, {
      company_id: value?._id,
      page: page + 1,
      limit: rowsPerPage,
      type: 'ICPA_EAMDINT',
    })
      .then(({ data }) => {
        if (data.signal) {
          let itemList = data.data
          setRow(itemList?.items ?? [])
          setTotalRows(itemList?.total ?? 0)
        } else {
          return showErrorMessage(data.message)
        }
      })
      .catch((err) => {
        console.log(err)
      })
    if (invoicesList) {
    }
  }

  useEffect(() => {
    if (show) {
      getData()
      getInvoicesList()
      getPaymentList()
    }
  }, [value, show])

  useEffect(() => {
    if (show) {
      getInvoicesList(page, rowsPerPage)
    }
  }, [page, rowsPerPage])

  useEffect(() => {
    if (show) {
      getPaymentList(page2, rowsPerPage2)
    }
  }, [page2, rowsPerPage2])

  const getPaymentList = async (page = 0, rowsPerPage = 10) => {
    makeRequest('get', `icpa/storage-transactions/get-list`, {
      company_id: value?._id,
      page: page + 1,
      limit: rowsPerPage,
      type: 'ICPA_EAMDINT',
    })
      .then(({ data }) => {
        if (data.signal) {
          let itemList = data.data
          setRow2(itemList?.items ?? [])
          setTotalRows2(itemList?.total ?? 0)
        } else {
          return showErrorMessage(data.message)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  let renderStatus = (status) => {
    if (status === 'paid') {
      return (
        <Tag bordered={false} className='ml-8 tag-marking-progress-2 mr-0'>
          Paid
        </Tag>
      )
    } else if (status === 'open') {
      return (
        <Tag bordered={false} className='ml-8 tag-draft mr-0'>
          Open
        </Tag>
      )
    } else if (status === 'overdue') {
      return (
        <Tag bordered={false} className='ml-8 tag-exam-completed-2 mr-0'>
          Overdue
        </Tag>
      )
    } else {
      return (
        <Tag bordered={false} className='ml-8 tag-draft mr-0'>
          {status}
        </Tag>
      )
    }
  }

  function splitArrayIntoThree(dataArray) {
    let total = dataArray.length;
    let groupSize2 = Math.ceil(total / 3); // Nhóm 2 luôn nhiều nhất
    let groupSize1 = Math.floor((total - groupSize2) / 2);

    let group1 = dataArray.slice(0, groupSize1);
    let group2 = dataArray.slice(groupSize1, groupSize1 + groupSize2);
    let group3 = dataArray.slice(groupSize1 + groupSize2);

    return [group1, group2, group3];
  }

  function getGroupByKey(dataArray, key) {
    const groups = splitArrayIntoThree(dataArray);
    return groups[key - 1] || [];
  }

  const PermissionsComponent = ({ title }) => {
    return (
      <div className="d-flex mt-8">
        <div className="icon-dot">
          <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M13 26.5C20.1799 26.5 26 20.6799 26 13.5C26 6.3201 20.1799 0.5 13 0.5C5.8201 0.5 0 6.3201 0 13.5C0 20.6799 5.8201 26.5 13 26.5Z"
              fill="#99A4C0"
            />
            <path
              d="M7.1167 14.3406L10.4785 17.7024L18.8831 9.29785"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div
          className="ml-14"
          style={{
            fontSize: "18px",
            color: "#0F1117",
          }}
        >
          {title}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className='mt-32'>
        <div
          style={{
            padding: '20px',
            borderRadius: '12px',
            minHeight: '214px',
            background: '#FFFFFF',
          }}
        >
          {isFree ? (
            <div className='row-sb'>
              <div className='d-flex align-items-center'>
                <div
                  className={`d-flex align-items-center justify-content-center icon-active`}
                >
                  <img src={'/images/free.svg'} />
                </div>
                <div className='f-semibold_24-20 ml-16'>Free plan</div>
              </div>
            </div>
          ) : (
            <div className='row-sb'>
              <div className='d-flex align-items-center'>
                <div
                  className={`d-flex align-items-center justify-content-center icon-active`}
                >
                  <img src={'/images/shield.svg'} />
                </div>
                <div>
                  <div className='f-semibold_24-20 ml-16'>
                    {' '}
                    {isCompanyBase ? 'Pro Plan - Default' : 'Add-on'}
                  </div>
                  <div className='f-medium_20 color-grey-500 ml-16'>
                    SGD {`$${plan?.price?.price ? plan?.price?.price : isCompanyBase ? "199" : '100'}`}{' '}
                    {plansInfo?.expires_on
                      ? `• Expires on ${plansInfo?.expires_on}`
                      : ''}{' '}
                    {plansInfo?.next_bill_on
                      ? `• Next bill on ${plansInfo?.next_bill_on}`
                      : ''}
                  </div>
                </div>
              </div>
            </div>
          )}

          <Divider style={{ border: '1px solid #C0C7D8' }} />
          <Row gutter={[16, 16]} align="top" className='pl-16'>
            {isFree ? (
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={8}>
                  {getGroupByKey(PERMISSIONS_FREE, 1).map((item, index) => {
                    let title = PERMISSIONS_PLAN[item];
                    if (item === "add_on_subsidiary_pro") {
                      title = (
                        <span>
                          {title} •{" "}
                          <span className="f-medium_26 text-color-grey">
                            Regular Price <span className=" text-line-through">SGD $300</span> • 12 months.
                          </span>
                        </span>
                      );
                    }
                    return title && <PermissionsComponent title={title} key={index} />;
                  })}
                </Col>
                <Col xs={24} sm={8}>
                  {getGroupByKey(PERMISSIONS_FREE, 2).map((item, index) => {
                    let title = PERMISSIONS_PLAN[item];
                    if (item === "add_on_subsidiary_pro") {
                      title = (
                        <span>
                          {title} •{" "}
                          <span className="f-medium_26 text-color-grey">
                            Regular Price <span className=" text-line-through">SGD $300</span> • 12 months.
                          </span>
                        </span>
                      );
                    }
                    return title && <PermissionsComponent title={title} key={index} />;
                  })}
                </Col>
                <Col xs={24} sm={8}>
                  {getGroupByKey(PERMISSIONS_FREE, 3).map((item, index) => {
                    let title = PERMISSIONS_PLAN[item];
                    if (item === "add_on_subsidiary_pro") {
                      title = (
                        <span>
                          {title} •{" "}
                          <span className="f-medium_26 text-color-grey">
                            Regular Price <span className=" text-line-through">SGD $300</span> • 12 months.
                          </span>
                        </span>
                      );
                    }
                    return title && <PermissionsComponent title={title} key={index} />;
                  })}
                </Col>
              </Row>
            ) : (
              <Row gutter={[16, 16]}>
                <Col xs={24} sm={8}>
                  {getGroupByKey(PERMISSIONS_PRO, 1).map((item, index) => {
                    let title = PERMISSIONS_PLAN[item];
                    if (item === "add_on_subsidiary_pro") {
                      title = (
                        <span>
                          {title} •{" "}
                          <span className="f-medium_26 text-color-grey">
                            Regular Price <span className=" text-line-through">SGD $300</span> • 12 months.
                          </span>
                        </span>
                      );
                    }
                    return title && <PermissionsComponent title={title} key={index} />;
                  })}
                </Col>
                <Col xs={24} sm={8}>
                  {getGroupByKey(PERMISSIONS_PRO, 2).map((item, index) => {
                    let title = PERMISSIONS_PLAN[item];
                    if (item === "add_on_subsidiary_pro") {
                      title = (
                        <span>
                          {title} •{" "}
                          <span className="f-medium_26 text-color-grey">
                            Regular Price <span className=" text-line-through">SGD $300</span> • 12 months.
                          </span>
                        </span>
                      );
                    }
                    return title && <PermissionsComponent title={title} key={index} />;
                  })}
                </Col>
                <Col xs={24} sm={8}>
                  {getGroupByKey(PERMISSIONS_PRO, 3).map((item, index) => {
                    let title = PERMISSIONS_PLAN[item];
                    if (item === "add_on_subsidiary_pro") {
                      title = (
                        <span>
                          {title} •{" "}
                          <span className="f-medium_26 text-color-grey">
                            Regular Price <span className=" text-line-through">SGD $300</span> • 12 months.
                          </span>
                        </span>
                      );
                    }
                    return title && <PermissionsComponent title={title} key={index} />;
                  })}
                </Col>
              </Row>
            )}
          </Row>
          {isFree ? (
            <></>
          ) : (
            <div
              style={{
                borderRadius: '12px',
                padding: '16px',
                minHeight: '88px',
                background: '#F4F7FE',
              }}
              className='rowy-center mt-16'
            >
              <div className='d-flex align-items-center justify-content-between width-full'>
                <div className='d-flex align-items-center justify-content-center'>
                  <div className='row-center'>
                    <img src={'/images/visa-icon.svg'} />
                  </div>
                  <div>
                    <div className='f-medium_20 color-grey-500 ml-16'>
                      {card?.card_number}
                    </div>
                    <div className='f-medium_20 color-grey-500 ml-16'>
                      Expires on {card?.expiry_date ? card?.expiry_date : ''}
                    </div>
                  </div>
                </div>
                <div className='d-flex align-items-center justify-content-center'></div>
              </div>
            </div>
          )}
        </div>
        {isFree ? (
          <></>
        ) : (
          <div>
            <div
              style={{
                padding: '20px',
                borderRadius: '12px',
                background: '#FFFFFF',
                marginTop: '24px',
              }}
              className='table-custom'
            >
              <div className='f-semibold_36 black-color mt-26 mb-12'>
                Billing History
              </div>
              <Table>
                <TableHead>
                  <TableRow className='default-black-color'>
                    <TableCell>Invoice</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Billing Date</TableCell>
                    <TableCell>Plan</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.length ? (
                    rows.map((row, key) => (
                      <TableRow key={`order-${row.id}-${key}`}>
                        <TableCell>{row?.identifier}</TableCell>
                        <TableCell>${row?.amount ?? 0}</TableCell>
                        <TableCell>
                          {row?.bill_date
                            ? moment(row?.bill_date).format('DD/MM/YYYY')
                            : ''}
                        </TableCell>
                        <TableCell>
                          {row?.plan_name === 'Pro'
                            ? 'Pro Plan - Default'
                            : row?.plan_name === 'Free'
                              ? 'Free Plan'
                              : row?.plan_name}
                        </TableCell>
                        <TableCell>
                          {renderStatus(row?.stripe_invoice_status)}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <></>
                  )}
                </TableBody>
              </Table>
              {totalRows > 10 && (
                <TablePagination
                  className='table-pagination-customer'
                  labelRowsPerPage={`Row per page`}
                  labelDisplayedRows={({ from, to, count }) => {
                    return `${from}-${to} of ${count}`
                  }}
                  rowsPerPageOptions={[10, 20, 50]}
                  component='div'
                  count={totalRows}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
              )}
            </div>

            <div
              style={{
                padding: '20px',
                borderRadius: '12px',
                background: '#FFFFFF',
                marginTop: '24px',
              }}
            >
              <div
                style={{
                  height: "74px",
                  width: "100%",
                  borderRadius: "12px",
                  border: "1px solid #C0C7D8",
                  background: "#F4F7FE",
                  padding: "16px",
                }}
                className="upload-custom"
              >
                <div className="width-full">
                  <div
                    style={{
                      marginTop: "-8px",
                    }}
                    className="mb-8"
                  >
                    <Progress percent={percent} strokeColor={"#338FEB"} showInfo={false} />
                  </div>
                  <div className="f-regular_20 color-grey-810">
                    {getStorageLimitNotDefault(value?.storage_size, isFree)} used of{" "}
                    {getStorageLimit(value?.storage_limit, isFree)}
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                padding: '20px',
                borderRadius: '12px',
                background: '#FFFFFF',
                marginTop: '24px',
              }}
              className='table-custom'
            >
              <div className='f-semibold_36 black-color mt-16 mb-12'>
                Payment History
              </div>
              <Table>
                <TableHead>
                  <TableRow className='default-black-color'>
                    <TableCell>Storage name</TableCell>
                    <TableCell>Storage size</TableCell>
                    <TableCell>Storage Price</TableCell>
                    <TableCell>Promotion code</TableCell>
                    <TableCell>Discount</TableCell>
                    <TableCell>Tax</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell style={{ minWidth: "160px" }}>Billing Date</TableCell>
                    <TableCell>Card number</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows2.length ? (
                    rows2.map((row, key) => (
                      <TableRow key={`order-${row.id}-${key}`}>
                        <TableCell>{row?.storage?.name ? <div>{row?.storage?.name}</div> : "--"}</TableCell>
                        <TableCell>{row?.storage?.name ? (
                          <div>
                            {row?.storage?.size} {row?.storage?.unit}
                          </div>
                        ) : (
                          "--"
                        )}</TableCell>
                        <TableCell>{row?.storage?.name ? <div>${row?.storage?.price}</div> : "--"}</TableCell>
                        <TableCell>{row?.discount?.promotion_code ?? "--"}</TableCell>
                        <TableCell>{row?.discount?.type === "percent"
                          ? `${row?.discount?.discount_value}%`
                          : row?.discount?.discount_value
                            ? `$${row?.discount?.discount_value}`
                            : `$0`}</TableCell>
                        <TableCell>{row?.tax_rate}%</TableCell>
                        <TableCell>${row?.amount ? row?.amount.toFixed(2) : 0}</TableCell>
                        <TableCell style={{ minWidth: "160px" }}>{row?.createdAt ? moment(row?.createdAt).format("DD/MM/YYYY HH:mm") : ""}</TableCell>
                        <TableCell>{row?.card_number}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <></>
                  )}
                </TableBody>
              </Table>
              {totalRows2 > 10 && (
                <TablePagination
                  className='table-pagination-customer'
                  labelRowsPerPage={`Row per page`}
                  labelDisplayedRows={({ from, to, count }) => {
                    return `${from}-${to} of ${count}`
                  }}
                  rowsPerPageOptions={[10, 20, 50]}
                  component='div'
                  count={totalRows2}
                  rowsPerPage={rowsPerPage2}
                  page={page2}
                  onChangePage={handleChangePage2}
                  onChangeRowsPerPage={handleChangeRowsPerPage2}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </>
  )
}
